<template>
  <div>
    <!-- <no-data v-if="!articleData"></no-data> -->

    <!-- 文章布局15或16 -->
    <article-panel
      v-if="layoutType === 15 || layoutType === 11"
      :articleData="articleDetail"
      :attachmentArr="attachmentArr"
      :articleTitle="articleTitle"
      :source="source"
      :time="time"
      :loading="loading"
    ></article-panel>

    <!-- 列表布局22或20（主题专栏） -->
    <list
      v-if="layoutType === 22 || layoutType === 20"
      :articleData="articleData"
      :menuID="menuID"
      @more="more"
      :articleTotal="articleTotal"
      :loading="loading"
    ></list>

    <!-- 两列布局（企业荣誉）11 -->
    <organization
      v-if="layoutType === 32"
      :articleData="articleData"
      :loading="loading"
    ></organization>

    <!-- 两列布局（公司报刊）13 -->
    <news v-if="layoutType === 33" :articleData="articleData" :loading="loading"></news>

    <!-- 视频布局（） -->
    <video-panel
      v-if="layoutType === 31"
      :articleData="articleData"
      :loading="loading"
    ></video-panel>
  </div>
</template>

<script>
import ArticlePanel from '@/components/layout/Article';
import List from '@/components/layout/List';
import Organization from '@/components/layout/Organization';
import News from '@/components/layout/News';
import VideoPanel from '@/components/layout/Video';
import NoData from '@/components/NoData';

export default {
  components: {
    ArticlePanel,
    List,
    Organization,
    News,
    VideoPanel,
    NoData,
  },
  props: ['layoutType', 'menuID'],
  data() {
    return {
      articleData: null,
      pageId: 1,
      articleTotal: null,
      // 以下五个都是传递给文章布局的数据，其实传递一个统一对象就行，但是由于之前只传了
      // articleDetail，现在修改article逻辑不如多穿几个数据方便
      articleDetail: null,
      attachmentArr: [],
      articleTitle: null,
      source: null,
      time: null,
      loading: false,
    };
  },
  watch: {
    menuID() {
      if (!this.$route.query.detailID) {
        this.getArticle();
      }
    },
    // 监听路由变化，二级或三级菜单更改时，重置pageId
    '$route.query.third'() {
      this.pageId = 1;
    },
    '$route.query.second'() {
      this.pageId = 1;
    },
    $route() {
      if (this.$route.query.detailID) {
        this.getDetail(this.$route.query.detailID);
      }
    },
  },
  mounted() {
    window.vue = this;
    if (this.$route.query.detailID) {
      this.getDetail(this.$route.query.detailID);
    } else {
      this.getArticle();
    }
  },
  methods: {
    // 通过父组件传递的菜单ID获取该菜单下的文章
    getArticle() {
      this.loading = true;
      let replacement = {
        menuID: this.menuID,
        pageId: 1,
      };

      let params;

      if (Number(this.$route.query.type) === 22) {
        params = {
          pageSize: 5,
        };
      } else {
        params = {
          pageSize: 10000000,
        };
      }

      this.$api.getArticle(replacement, params).then((res) => {
        this.attachmentArr = [];
        if (res.articleList.length === 1) {
          this.countClick(res.articleList[0].id);
        }
        // 单片文章无标题
        if (Number(this.$route.query.type) === 16) {
          this.articleTitle = null;
          this.source = null;
          this.time = null;
        }
        this.articleData = res;
        if (res.articleList.length > 0) {
          this.articleDetail = res.articleList[0].contentH;
          if (res.articleList[0].accessoryList.length > 0) {
            for (let attachment of res.articleList[0].accessoryList) {
              this.attachmentArr.push(attachment);
            }
          }
        } else {
          this.articleDetail = null;
        }
        this.articleTotal = res.total;

        this.loading = false;
      });
    },
    // 点击更多显示更多数据
    more(pageId) {
      this.pageId += 1;

      let replacement = {
        menuID: this.menuID,
      };

      let params;

      if (Number(this.$route.query.type) === 22) {
        params = {
          pageSize: 5,
          pageId: this.pageId,
        };
      } else {
        params = {
          pageSize: 10000000,
          pageId: this.pageId,
        };
      }

      this.$api.getArticle(replacement, params).then((res) => {
        this.articleData.articleList = this.articleData.articleList.concat(res.articleList);
      });
    },
    getDetail(menuID) {
      this.loading = true;
      this.countClick(menuID);
      let replacement = {
        menuID: menuID,
      };

      this.$api.getArticleDetail(replacement).then((res) => {
        this.articleTitle = res.title;
        this.source = res.artSource;
        this.time = res.addTime;
        this.articleDetail = res.contentH;
        if (res.accessoryList.length > 0) {
          for (let attachment of res.accessoryList) {
            this.attachmentArr.push(attachment);
          }
        }

        this.loading = false;
      });
    },
    countClick(id) {
      let replacement = {
        articleID: id,
      };
      this.$api.countClick(replacement).then((res) => {});
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/pages/content/Layout.vue